import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import { Backdrop, CircularProgress, Button, Box } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import { printLot, InvoiceDetails } from "../../../adminModel/auctions";
import "./printInvoise.css";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  importButton: {
    marginRight: theme.spacing(1),
  },
}));

function PrintReview({
  status,
  handleClose,
  eventId,
  lotNumberData,
  customerName,
  EventName,
  Email,
  receiptNumber,
  eventDate,
  addons = [],
  withImage = true,
  invoice = null,
   hidePreview = false,
   buyer_premium = null
}) {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalSub, setTotalSub] = useState("0");
  const [totalHp, setTotalHP] = useState("0");
  const [totalBP, setTotalBP] = useState("0");
  const [ bpStatem, setBpState] = useState("0")
  const [detailsInvoice, setInvoiceDetails] = useState("");
const invoiceAddons =
  invoice &&
  Array.isArray(invoice.addons) &&
  invoice.addons.length > 0
    ? invoice.addons
    : addons || [];
  // =========================
  // DATE FORMAT
  // =========================

  const formatDate = (dateStr) => {
    if (!dateStr || dateStr === "0000-00-00") return "---";

    const date = new Date(dateStr);

    return isNaN(date.getTime())
      ? dateStr
      : new Intl.DateTimeFormat("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }).format(date);
  };

  // =========================
  // FETCH AUCTION DATA
  // =========================

  useEffect(() => {
   
    if (!status) return;

    const fetchAuctionData = async () => {
      try {
        /*
         * Individual invoice:
         *   uses printLot(lotNumberData, eventId)
         *
         * Invoice History:
         *   may already contain invoice item data.
         *   If not, fall back to printLot using the invoice's
         *   auction + lot numbers.
         */
        let results = [];

        if (
          invoice &&
          Array.isArray(invoice.items) &&
          invoice.items.length
        ) {
          // Keep the invoice item data first.
          results = invoice.items.map((item) => ({
            ...item,
            lot_number:
              item.lot_number ??
              item.lotNumber ??
              "",
            hp:
              item.hp ??
              item.hammer_price ??
              0,
            buyers_premium:
              item.buyers_premium ??
              item.buyer_premium ??
              0,
            total_hp:
              item.total_hp ??
              item.total_price ??
              (
                parseFloat(item.hp || item.hammer_price || 0) +
                parseFloat(
                  item.buyers_premium ||
                  item.buyer_premium ||
                  0
                )
              ),
            img_url:
              item.img_url ||
              item.image_url ||
              item.imageUrl ||
              item.image ||
              item.photo_url ||
              item.photo ||
              item.img ||
              null,
          }));

          // IMPORTANT:
          // invoice_items_new may not contain the artwork URL.
          // printLot already knows how to retrieve the auction lot
          // data, including img_url, so use it as a fallback.
          const missingImageLots = results
            .filter((item) => !item.img_url)
            .map((item) => String(item.lot_number || "").trim())
            .filter(Boolean);

          if (eventId && missingImageLots.length) {
            try {
              const fetched = await printLot(
                [...new Set(missingImageLots)].join(","),
                eventId
              );

              if (Array.isArray(fetched) && fetched.length) {
                const fetchedByLot = {};

                fetched.forEach((item) => {
                  const lot = String(
                    item.lot_number ??
                    item.lotNumber ??
                    item.id ??
                    ""
                  ).trim();

                  if (lot) {
                    fetchedByLot[lot] = item;
                  }
                });

                results = results.map((item) => {
                  if (item.img_url) return item;

                  const lot = String(item.lot_number || "").trim();
                  const fallback = fetchedByLot[lot];

                  if (!fallback) return item;

                  return {
                    ...fallback,
                    ...item,
                    img_url:
                      item.img_url ||
                      fallback.img_url ||
                      fallback.image_url ||
                      fallback.imageUrl ||
                      fallback.image ||
                      fallback.photo_url ||
                      fallback.photo ||
                      fallback.img ||
                      null,
                  };
                });
              }
            } catch (imageError) {
              console.error(
                "Unable to load artwork images from printLot:",
                imageError
              );
            }
          }
        } else if (eventId && lotNumberData) {
          const lotNumbers = Array.isArray(lotNumberData)
            ? lotNumberData
                .map((lot) =>
                  typeof lot === "object"
                    ? (
                        lot.lot_number ??
                        lot.lotNumber ??
                        lot.id ??
                        ""
                      )
                    : lot
                )
                .filter(Boolean)
                .join(",")
            : String(lotNumberData)
                .replace(/\n/g, ",")
                .split(",")
                .map((lot) => lot.trim())
                .filter(Boolean)
                .join(",");

          const fetched = await printLot(
            lotNumbers,
            eventId
          );

          results = Array.isArray(fetched)
            ? fetched
            : [];
        }

        const sorted = [...results].sort(
          (a, b) =>
            Number(a.lot_number || 0) -
            Number(b.lot_number || 0)
        );

        setData(sorted);

        const hp = sorted.reduce(
          (acc, curr) =>
            acc +
            parseFloat(
              curr.hp ??
              curr.hammer_price ??
              0
            ),
          0
        );

        const bp = sorted.reduce(
          (acc, curr) =>
            acc +
            parseFloat(
              curr.buyers_premium ??
              curr.buyer_premium ??
              0
            ),
          0
        );

      const addSum = invoiceAddons.reduce(
  (acc, curr) =>
    acc + Number(curr.price || 0),
  0
);

        const grandTotal = sorted.reduce(
          (acc, curr) =>
            acc +
            parseFloat(
              curr.total_hp ??
              curr.total_price ??
              (
                parseFloat(
                  curr.hp ??
                  curr.hammer_price ??
                  0
                ) +
                parseFloat(
                  curr.buyers_premium ??
                  curr.buyer_premium ??
                  0
                )
              )
            ),
          0
        ) + addSum;
        
        setTotalHP(
          hp.toLocaleString(undefined, {
            maximumFractionDigits: 0,
          })
        );

        setTotalBP(
          bp.toLocaleString(undefined, {
            maximumFractionDigits: 0,
          })
        );

        setTotalSub(
          grandTotal.toLocaleString(undefined, {
            maximumFractionDigits: 0,
          })
        );
    
      } catch (error) {
        console.error(
          "FETCH INVOICE PREVIEW ERROR:",
          error
        );

        setData([]);
        setTotalHP("0");
        setTotalBP("0");
        setTotalSub("0");
      }
    };

    fetchAuctionData();
     
  }, [status, lotNumberData, eventId, addons, invoice]);

  // =========================
  // INVOICE DETAILS
  // =========================

  useEffect(() => {
    const getInvoiceDetails = async () => {
      try {
        const results = await InvoiceDetails();

        if (results?.value_desc) {
          setInvoiceDetails(results.value_desc);
          setBpState(results)
     
        }
      } catch (error) {
        console.error(error);
      }
    };

    getInvoiceDetails();
  }, []);

  // =========================
  // INVOICE TABLE
  // =========================

  const getImageUrl = (value) => {
    const raw =
      value?.img_url ||
      value?.image_url ||
      value?.imageUrl ||
      value?.image ||
      value?.photo_url ||
      value?.photo ||
      value?.img ||
      "";

    if (!raw || typeof raw !== "string") return "";

    const url = raw.trim();
    if (!url) return "";

    if (
      url.startsWith("http://") ||
      url.startsWith("https://") ||
      url.startsWith("data:") ||
      url.startsWith("blob:")
    ) {
      return url;
    }

    if (url.startsWith("//")) {
      return `${window.location.protocol}${url}`;
    }

    try {
      return new URL(url, window.location.origin).href;
    } catch (e) {
      return url;
    }
  };

  const InvoiceTable = () => {
    const line = "0.5px solid #d1c9c9";

    return (
      <div
        style={{
          width: "100%",
          marginTop: "15px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* HEADER */}

        <div
          style={{
            display: "flex",
            fontWeight: "bold",
            fontSize: "12px",
            borderBottom: line,
          }}
        >
          <div
            style={{
              width: "25%",
              padding: "8px",
              textAlign: "center",
            }}
          >
            ARTIST
          </div>

          <div
            style={{
              width: "45%",
              padding: "8px",
              textAlign: "center",
            }}
          >
            LOT DETAILS
          </div>

          <div
            style={{
              width: "30%",
              padding: "8px",
              textAlign: "center",
            }}
          >
            BID PRICE
          </div>
        </div>

        {/* BODY */}

        {data.map((value, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              pageBreakInside: "avoid",
              breakInside: "avoid",
              borderLeft: line,
              borderRight: line,
              borderBottom: line,
            }}
          >
            {/* ARTIST */}

            <div
              style={{
                width: "25%",
                padding: "10px 8px",
                borderRight: line,
                fontSize: "11px",
                textAlign: "center",
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: value.artist || "",
                }}
              />
            </div>

            {/* LOT DETAILS */}

            <div
              style={{
                width: "45%",
                padding: "10px 8px",
                borderRight: line,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "bold",
                }}
              >
                LOT {value.lot_number}
              </div>

              {/* =========================
                  IMAGE
                  CHECKED = SHOW
                  UNCHECKED = HIDE
              ========================= */}

              {withImage && getImageUrl(value) && (
                <img
                  src={getImageUrl(value)}
                  crossOrigin="anonymous"
                  alt="lot"
                  onError={(e) => {
                    console.error(
                      "ARTWORK IMAGE LOAD FAILED:",
                      getImageUrl(value)
                    );
                    e.currentTarget.style.display = "none";
                  }}
                  style={{
                    width: "110px",
                    maxWidth: "100%",
                    height: "auto",
                    maxHeight: "150px",
                    objectFit: "contain",
                    display: "block",
                    margin: "8px auto",
                  }}
                />
              )}

              <div
                style={{
                  fontSize: "11px",
                }}
                dangerouslySetInnerHTML={{
                  __html: value.title || "",
                }}
              />
            </div>

            {/* BID PRICE */}

            <div
              style={{
                width: "30%",
                padding: "10px 8px",
              }}
            >
              <div
                style={{
                  fontSize: "11px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "6px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Hammer Price:
                  </span>

                  <span>
                    {parseFloat(
                      value.hp || 0
                    ).toLocaleString()}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Buyer's Premium: 
                  </span>

                  <span>
                    {parseFloat(
                      value.buyers_premium || 0
                    ).toLocaleString()}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Sub Total:
                  </span>

                  <span>
                    {parseFloat(
                      value.total_hp || 0
                    ).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* SUMMARY */}

        <div
          style={{
            display: "flex",
            pageBreakInside: "avoid",
            breakInside: "avoid",
            borderLeft: line,
            borderRight: line,
            borderBottom: line,
          }}
        >
          <div
            style={{
              width: "70%",
              padding: "12px 10px",
              borderRight: line,
              textAlign: "right",
              fontWeight: "bold",
              fontSize: "11px",
            }}
          >
            <div>Sub Total</div>

            <div>Buyer's Premium ({(buyer_premium * 100 ) + `%`})</div>

          {invoiceAddons.map(
            (a, idx) => {
              const description =
                a.description ||
                a.discription ||
                "";

              if (!description) {
                return null;
              }

              return (
                <div key={idx}>
                  {String(
                    description
                  ).toUpperCase()}
                </div>
              );
            }
          )}

            <div
              style={{
                fontSize: "14px",
                marginTop: "8px",
              }}
            >
              Total
            </div>
          </div>

          <div
            style={{
              width: "30%",
              padding: "12px 10px",
              textAlign: "right",
              fontSize: "11px",
            }}
          >
            <div>{totalHp}</div>

            <div>{totalBP}</div>

            {invoiceAddons.map(
          (a, idx) =>
            Number(a.price || 0) !== 0 ? (
              <div key={idx}>
                {Number(
                  a.price || 0
                ).toLocaleString()}
              </div>
            ) : null
        )}

            <div
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "8px",
              }}
            >
              PHP {totalSub}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // =========================
  // RENDER INVOICE
  // =========================

  const renderInvoiceHTML = () => {
    const logoUrl =
      "https://app.leon-gallery.com/static/logo140.png";

    return (
      <div
        id="pdf-render-area"
        style={{
          padding: "40px",
          backgroundColor: "#fff",
          color: "#000",
          fontFamily: "Arial",
          width: "750px",
          margin: "auto",
          boxSizing: "border-box",
        }}
      >
        {/* HEADER */}

        <table
          id="invoice-top-header"
          style={{ width: "100%" }}
        >
          <tbody>
            <tr>
              <td align="left">
                <img
                  src={logoUrl}
                  crossOrigin="anonymous"
                  style={{
                    width: "180px",
                  }}
                  alt="logo"
                />
              </td>

              <td
                align="right"
                style={{
                  fontSize: "10px",
                  fontStyle: "italic",
                  lineHeight: "1.2",
                }}
              >
                www.leon-gallery.com
                <br />
                leongallerymakati@gmail.com
              </td>
            </tr>
          </tbody>
        </table>

        {/* TITLE */}

        <h1
          style={{
            textAlign: "center",
            fontWeight: "bold",
            margin: "20px 0",
            letterSpacing: "2px",
            textTransform: "uppercase",
            fontSize: "24px",
          }}
        >
          Invoice
        </h1>

        {/* INFORMATION */}

        <div
          style={{
            marginBottom: "20px",
            fontSize: "13px",
          }}
        >
          <p style={{ margin: "2px 0" }}>
            <b>Receipt No:</b> {receiptNumber}
          </p>

          <p style={{ margin: "2px 0" }}>
            <b>Name:</b> {customerName}
          </p>

          <p style={{ margin: "2px 0" }}>
            <b>Auction:</b> {EventName}
          </p>

          <p style={{ margin: "2px 0" }}>
            <b>Date:</b> {formatDate(eventDate)}
          </p>
        </div>

        {/* TABLE */}

        <InvoiceTable />

        {/* SIGNATURE */}

        <div
          style={{
            marginTop: "40px",
            textAlign: "right",
            pageBreakInside: "avoid",
            breakInside: "avoid",
          }}
        >
          <div
            style={{
              width: "220px",
              borderTop: "1px solid #000",
              display: "inline-block",
              textAlign: "center",
              paddingTop: "5px",
            }}
          >
            <p
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                margin: 0,
              }}
            >
              Authorized Signature
            </p>
          </div>
        </div>

        {/* INVOICE DETAILS */}

        <div
          style={{
            marginTop: "30px",
            fontSize: "10px",
            lineHeight: "1.4",
            borderTop: "1px solid #eee",
            paddingTop: "10px",
            pageBreakInside: "avoid",
            breakInside: "avoid",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: "12px",
              marginBottom: "6px",
            }}
          >
            PAYMENT INSTRUCTIONS
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: detailsInvoice,
            }}
          />
        </div>
      </div>
    );
  };

  // =========================
  // PRINT
  // =========================

  const printInvoice = () => {
    const element = document.getElementById("pdf-render-area");

    if (!element) {
      alert.error("Invoice preview not found.");
      return;
    }

    const printWindow = window.open(
      "",
      "_blank",
      "width=900,height=1000"
    );

    if (!printWindow) {
      alert.error("Please allow pop-ups to print the invoice.");
      return;
    }

    printWindow.document.open();

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8" />
          <title>Invoice ${String(receiptNumber || "")}</title>

          <style>
            /* ======================================================
               PRINT PAGE
            ====================================================== */

            @page {
              size: 10.125in 12.25in;
              margin: 0.35in 0.50in 0.35in 0.50in;
            }

            html,
            body {
              margin: 0;
              padding: 0;
              background: #fff;
            }

            body {
              font-family: Arial, Helvetica, sans-serif;
              color: #000;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            /*
             * IMPORTANT:
             * The header/footer are inside THEAD/TFOOT.
             * Browsers repeat THEAD/TFOOT on every printed page,
             * including the last page.
             */
            #print-layout {
              width: 100%;
              border-collapse: collapse;
              border-spacing: 0;
              table-layout: fixed;
            }

            #print-layout thead {
              display: table-header-group;
            }

            #print-layout tfoot {
              display: table-footer-group;
            }

            #print-layout tbody {
              display: table-row-group;
            }

            #print-layout thead td {
              padding: 0 0 12px 0;
              vertical-align: top;
            }

            #print-layout tfoot td {
              padding: 12px 0 0 0;
              vertical-align: top;
            }

            /* ======================================================
               REPEATING HEADER
            ====================================================== */

            .print-header-wrap {
              width: 100%;
              box-sizing: border-box;
              border-bottom: 1px solid #e5e5e5;
              padding-bottom: 8px;
            }

            .print-header-table {
              width: 100%;
              border-collapse: collapse;
            }

            .print-header-left {
              width: 60%;
              text-align: left;
              vertical-align: top;
            }

            .print-header-right {
              width: 40%;
              text-align: right;
              vertical-align: top;
              font-size: 10px;
              font-style: italic;
              line-height: 1.25;
              padding-top: 3px;
            }

            .print-header-logo {
              width: 180px;
              height: auto;
              display: block;
            }

            /* ======================================================
               REPEATING FOOTER
            ====================================================== */

            .print-footer-wrap {
              width: 100%;
              box-sizing: border-box;
              border-top: 1px solid #d9d9d9;
              padding-top: 6px;
              text-align: center;
              font-size: 9px;
              line-height: 1.3;
            }

            /* ======================================================
               INVOICE CONTENT
            ====================================================== */

            #print-content {
              width: 100%;
              box-sizing: border-box;
              margin: 0;
              padding: 0 !important;
              background: #fff;
            }

            /* Remove the original header from the copied invoice.
             * The repeating THEAD header is used instead.
             */
            #print-content #invoice-top-header {
              display: none !important;
            }

            /* The copied invoice already has its own title/information.
             * Keep the original design and spacing as much as possible.
             */
            #print-content > div {
              box-sizing: border-box;
            }

            table,
            tr,
            td,
            th {
              page-break-inside: auto;
            }

            img {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .pagebreak {
              display: block;
              page-break-after: always;
              break-after: page;
            }

            .break-before {
              display: block;
              page-break-before: always;
              break-before: page;
            }
          </style>
        </head>

        <body>
          <table id="print-layout">
            <thead>
              <tr>
                <td>
                  <div class="print-header-wrap">
                    <table class="print-header-table">
                      <tr>
                        <td class="print-header-left">
                          <img
                            class="print-header-logo"
                            src="https://app.leon-gallery.com/static/logo140.png"
                            crossorigin="anonymous"
                            alt="Leon Gallery"
                          />
                        </td>

                        <td class="print-header-right">
                          www.leon-gallery.com<br />
                          leongallerymakati@gmail.com
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </thead>

            <tfoot>
              <tr>
                <td>
                  <div class="print-footer-wrap">
                    G/F Eurovilla 1, Rufino Corner Legazpi Streets,<br />
                    Legazpi Village, Makati City, Philippines<br />
                    Tel no. (632) 856-2781
                  </div>
                </td>
              </tr>
            </tfoot>

            <tbody>
              <tr>
                <td style="padding: 0; vertical-align: top;">
                  <div id="print-content">
                    ${element.outerHTML}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    `);

    printWindow.document.close();

    const printNow = () => {
      printWindow.focus();
      printWindow.print();
    };

    /* Give the logo/images time to load before opening print. */
    const images = printWindow.document.images;

    if (!images.length) {
      setTimeout(printNow, 300);
      return;
    }

    let loaded = 0;
    let printed = false;

    const startPrint = () => {
      if (printed) return;
      printed = true;
      setTimeout(printNow, 250);
    };

    Array.from(images).forEach((img) => {
      if (img.complete) {
        loaded += 1;
      } else {
        img.onload = () => {
          loaded += 1;
          if (loaded === images.length) {
            startPrint();
          }
        };

        img.onerror = () => {
          loaded += 1;
          if (loaded === images.length) {
            startPrint();
          }
        };
      }
    });

    if (loaded === images.length) {
      startPrint();
    }

    /* Safety fallback in case the external logo does not fire an event. */
    setTimeout(startPrint, 1500);
  };

  // =========================
  // PREVIEW
  // =========================

 return (
  <React.Fragment>
    <Dialog
      fullWidth
      maxWidth="lg"
      open={status}
      onClose={handleClose}
      BackdropProps={
        hidePreview
          ? {
              style: {
                display: "none",
              },
            }
          : undefined
      }
      PaperProps={
        hidePreview
          ? {
              style: {
                position: "fixed",
                left: 0,
                top: 0,
                width: "800px",
                opacity: 0,
                pointerEvents: "none",
                boxShadow: "none",
                visibility: "hidden",
                zIndex: -1,
              },
            }
          : undefined
      }
    >
      <DialogContent
        style={{
          padding: 0,
          backgroundColor: "#e5e5e5",
          overflow: "auto",
        }}
      >
        <div
          style={{
            minHeight: "100%",
            padding: "35px 20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "0 4px 18px rgba(0,0,0,0.18)",
              margin: "0 auto",
              flexShrink: 0,
            }}
          >
            {renderInvoiceHTML()}
          </div>
        </div>
      </DialogContent>

      {!hidePreview && (
        <Box
          style={{
            padding: "12px 18px",
            backgroundColor: "#fff",
            borderTop: "1px solid #ddd",
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={printInvoice}
          >
            Print
          </Button>

          <Button
            variant="outlined"
            onClick={handleClose}
          >
            Close
          </Button>
        </Box>
      )}

      <Backdrop
        className={classes.backdrop}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  </React.Fragment>
);
}

export default PrintReview;